import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@wordpress/components'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { withOrderFormContext } from '../../contexts'

const SubmitButton = ({ isSubmitting, images, frameSize, setShowCartModal }) => {
  const [disabled, setDisabled] = useState(true)

  // Only let submit button clickable if frame size is selected and images are chosen.
  // @TODO: Need to check for required attributes and invalid images also.
  useEffect(() => {
    const validImages = images && images.length > 0

    setDisabled(!validImages || !frameSize)
  }, [images, frameSize])

  const _showCartModal = () => setShowCartModal(true)

  // Only display submit button if frame size is selected.
  return frameSize && (
    <div className="SubmissionContainer">
      <Button isPrimary onClick={_showCartModal} disabled={disabled}>
        <ShoppingCartOutlined className="cart-icon"/> {isSubmitting ? 'Adding...' : 'Review and Add to Cart'}
      </Button>
    </div>
  )
}

SubmitButton.propTypes = {
  isSubmitting: PropTypes.bool,
  frameSize: PropTypes.object,
  images: PropTypes.array,
  setShowCartModal: PropTypes.func.isRequired
}

export default withOrderFormContext(context => ({
  images: context.images,
  frameSize: context.frameSize,
  isSubmitting: context.isSubmitting,
  setShowCartModal: context.setShowCartModal
}))(SubmitButton)
